import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '恋爱漫画', href: '/category/romance' },
      { label: '校园漫画', href: '/category/school' },
      { label: '奇幻漫画', href: '/category/fantasy' },
      { label: '热血漫画', href: '/category/action' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '用户口碑', href: '/about#reputation' },
      { label: '联系我们', href: '/about#contact' },
      { label: '版权声明', href: '/about' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '凤舞九天', href: '/article/m6' },
      { label: '社长大人别碰我', href: '/article/m1' },
      { label: '剑与魔法学院', href: '/article/m2' },
      { label: '暗夜追踪者', href: '/article/m4' },
    ],
  },
];

const categoryLinks = [
  { label: '悬疑', href: '/category/mystery' },
  { label: '搞笑', href: '/category/comedy' },
  { label: '古风', href: '/category/historical' },
  { label: '都市', href: '/category/urban' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-lg text-background-50"></i>
              </span>
              <span className="text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>韩漫屋</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              海量免费正版韩国漫画在线阅读平台，每日更新热门韩漫，为您带来优质的韩漫阅读体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {/* Link Groups */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫屋 HANMANWU.COM - 本站所有漫画均来自正规版权合作方，未经许可禁止转载
          </p>
          <div className="flex items-center gap-4 flex-wrap">
            {categoryLinks.map((link) => (
              <Link key={link.label} to={link.href} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}